module.exports = __webpack_public_path__ + "assets/ic_character3.53646187.svg";